import { VideoSizes } from '@anm/HostingPlayer';
import { getHostingStatsData } from '@anm/components/user/UserLimits/helpers';
import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import useVideoSizes from '@anm/hooks/useVideoSizes';
import { FC, RefObject } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from '../../../../../store/modules/user';
import { BlockedVideoWrapper } from '../Wrapper';

import getFirstDayOfNextMonth from './helpers/getFirstDayOfNextMonth';

type BlockedVideoProps = {
  sizes: VideoSizes;
  container: RefObject<HTMLDivElement>;
  fullWidth?: boolean;
};

const BlockedVideo: FC<BlockedVideoProps> = props => {
  const playerSizes = useVideoSizes(props);
  const hostingStats = useSelector(userSelectors.selectUserHostingStats);
  const { isWarning, diffBytes, used } = getHostingStatsData({
    data: hostingStats?.data,
    extraItemCost: 0
  });

  const isTrafficLimit = isWarning && diffBytes > 0;

  const blockedMessage = isTrafficLimit ? ( // if blocked because of traffic we show prepared message, othervise we show default message
    <p>
      You’ve reached your {used} monthly traffic limit. Your hosted videos have been disabled until&nbsp;
      {getFirstDayOfNextMonth()}. To increase the monthly bandwidth,&nbsp;
      <a {...getUpgradeLinkProps()}>upgrade to a higher plan</a>
    </p>
  ) : (
    <p>This video is blocked</p>
  );

  return <BlockedVideoWrapper {...playerSizes}>{blockedMessage}</BlockedVideoWrapper>;
};

export default BlockedVideo;
